// extracted by mini-css-extract-plugin
module.exports = {"square":"styles_square__YyB4H"};